import { settings } from '../../settings';
import noImageAvailable from './noImageAvailable.jpg';

export default function getPhotoUrl(entity:string , hash:string , ext:string):string{
    
    if (!entity || !hash || !ext) {
        return noImageAvailable;
    }
    
    const url = settings.storageUrl;
    const filePath = `${url}upload/${entity}/${hash}.${ext}`;
    return filePath;
}

